<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div
  class="w-100 d-flex align-items-baseline justify-content-between gap-2"
  *ngIf="!versionHistoryData.isVersonHistory"
>
  <ul class="nav template3_nav nav nav-tabs border-0 mt-2">
    <li class="nav-item" *ngFor="let tab of tabs; let sr = index">
      <a
        class="nav-link"
        [class.active]="active == sr"
        (click)="setTab(tab, sr)"
      >
        Approach {{ sr + 1 }}</a
      >
    </li>
  </ul>
  <button class="btn btn-sm add-btn-round" (click)="addAdditonalApproach()">
    <lucide-icon name="plus" size="14"></lucide-icon>Add Additional Approach
  </button>
</div>
<app-bread-crumbs [(breadCampsList)]="breadCampsList"></app-bread-crumbs>
<app-progress-bar [isLoading]="isLoader"></app-progress-bar>
<div class="interpretation_section">
  <div>
    <app-front
      *ngIf="!isLoader"
      [summaryDetailsId]="summaryId"
      [user]="user"
      [tabName]="'Approach'"
      [selfAssessmentDocument]="selfAssessmentDocument"
      [tab]="tab"
      [(assessmentData)]="approachList"
      [interpretationAssessmentDropdownList]="approachAssessmentDropdownList"
      (notifyCkEditorChnage)="notifyDetailsComponentCkEditorChange($event)"
      [versionHistoryData]="versionHistoryData"
      (isReadyForReviewChanged)="isReadyForReviewChanged($event)"
      (afterSave)="setPreviousData()"
    ></app-front>
  </div>
  <div class="mt-3">
    <app-review
      *ngIf="approachList.readyForReview && !isLoader"
      [summaryDetailsId]="summaryId"
      [user]="user"
      [tabName]="'Approach'"
      [selfAssessmentDocument]="selfAssessmentDocument"
      [(assessmentData)]="approachList"
      [interpretationAssessmentDropdownList]="approachAssessmentDropdownList"
      (notifyCkEditorChnage)="notifyDetailsComponentCkEditorChange($event)"
      [versionHistoryData]="versionHistoryData"
      (isReadyForApprovalChanged)="isReadyForApprovalChanged($event)"
      (afterSave)="setPreviousData()"
    >
    </app-review>
  </div>
  <div class="mt-3">
    <app-approvals
      *ngIf="approachList.readyForApproval && !isLoader"
      [summaryDetailsId]="summaryId"
      [tabName]="'Approach'"
      [(approvalsData)]="approachList"
      [interpretationAssessmentDropdownList]="approachAssessmentDropdownList"
      [selfAssessmentDocument]="selfAssessmentDocument"
      [user]="user"
      (notifyCkEditorChnage)="notifyDetailsComponentCkEditorChange($event)"
      [versionHistoryData]="versionHistoryData"
      (isReadyForConditionalApprovalChanged)="isReadyForConditionalApprovalChanged($event)"
      (afterSave)="setPreviousData()"
    ></app-approvals>
  </div>
  <div class="mt-3">
    <app-conditional-approval
      *ngIf="approachList.conditionalApproval && !isLoader"
      [summaryDetailsId]="summaryId"
      [user]="user"
      [selfAssessmentDocument]="selfAssessmentDocument"
      [tabName]="'Approach'"
      [(assessmentData)]="approachList"
      [interpretationAssessmentDropdownList]="approachAssessmentDropdownList"
      (notifyCkEditorChnage)="notifyDetailsComponentCkEditorChange($event)"
      [versionHistoryData]="versionHistoryData"
      (afterSave)="setPreviousData()"
    ></app-conditional-approval>
  </div>
</div>
